export const footerLinks = {
  facebook: 'http://www.facebook.com/sharer.php?u=https://www.phoenixcontact.com/plcnext',
  github: 'https://github.com/plcnext ',
  linkedin: 'https://de.linkedin.com/company/phoenix-contact',
  youtube: 'https://www.youtube.com/playlist?list=PL9PpVy4avE5FAH7i_4_b7uO_GHVnZn7_I',
  plcnext: 'https://www.plcnext-community.net/en/',
  phoenixContact: 'https://www.phoenixcontact.com/',
  plcnextCommunity: 'https://www.plcnext-community.net/',
  customerTermsUS: `/Customer-Terms-PLCnext_Store_US.pdf`,
  customerTermsEU: `/Customer-Terms-PLCnext_Store_EU.pdf`,
  customerTermsWorld: `/Customer-Terms-PLCnext_Store_EU.pdf`,
  softwareLicenseTerms: `/SoftwareLicenseTerms.pdf`,
  pcAppstoreTermsCondCustomer: `/Customer-Terms-PLCnext_Store.pdf`,
  pcAppstoreTermsCondContributor: `/Developer-Terms-for-PLCnext-Store.pdf`,
  siteNoticeEUOrWorld: 'https://www.phoenixcontact.com/en-pc/impressum',
  siteNoticeUS: 'https://www.phoenixcontact.com/en-us/impressum',
  dataPrivacy: `https://phoe.co/corporate_data_protection`,
  youTubeTechnicalSupport: 'https://www.youtube.com/phoenixcontacttechnicalsupport ',
};

export const headerLinks = {
  FAQ: 'https://store.plcnext.help/st/PLCnext_Store_FAQ.htm',
  manual: 'https://store.plcnext.help/st/Home.htm',
};

export const privacyPolicyLink = 'https://phoe.co/corporate_data_protection';

export const licSdLinks = {
  gb8: 'https://www.phoenixcontact.com/en-pc/products/program-configuration-memory-sd-flash-8gb-plcnext-memory-lic-1151112',
  gb32: 'https://www.phoenixcontact.com/en-pc/products/program-configuration-memory-sd-flash-32gb-plcnext-memory-lic-1151111',
};
